import * as React from 'react';

/** @deprecated Work with your designer to replace with one of the current illustrations (https://lens.loom.dev/illustrations/illustration-set). */
function IllustrationGettingStarted(props) {
  return (
    <svg
      viewBox="0 0 106 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53 101c26.51 0 48-21.49 48-48S79.51 5 53 5 5 26.49 5 53s21.49 48 48 48z"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M53 100.986c26.51 0 48-14.563 48-32.527 0-17.965-21.49-32.528-48-32.528S5 50.494 5 68.46c0 17.964 21.49 32.527 48 32.527z"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M53 100.998c26.51 0 48-8.682 48-19.39 0-10.71-21.49-19.391-48-19.391S5 70.898 5 81.607c0 10.71 21.49 19.391 48 19.391z"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M53 100.984c26.51 0 48-3.908 48-8.728S79.51 83.53 53 83.53 5 87.436 5 92.256s21.49 8.728 48 8.728z"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
    </svg>
  );
}

export default IllustrationGettingStarted;
